import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Card, Typography, Chip, IconButton, Icon } from '@material-ui/core';
import NumberFormat from 'react-number-format';
import { BackdropCircular } from 'components';
import { makeStyles } from '@material-ui/core/styles';
import MUIDataTable from 'mui-datatables';
import logo from 'components/Logo/logo-dermpro.svg';


const useStyles = makeStyles(() => ({
  root: {
    '& .MuiTableCell-root.MuiTableCell-body': {
      padding: '0'
    },
    '& [class^="MUIDataTableBodyCell-root"]': {
      padding: '0'
    },
    '& .MuiTableCell-root.MuiTableCell-head': {
      padding: '10px 2px'
    }
  },
  tableRowText: {
    fontSize: '14px',
    letterSpacing: '0.5px',
    lineHeight: '32px',
    wordBreak: 'keep-all',
  },
  tableTitle: {
    fontSize: '15px',
    fontWeight: 500,
    letterSpacing: '0.5px',
    lineHeight: '32px',
    wordBreak: 'keep-all',
  }
}));

const BestSellers = () => {
  const classes = useStyles();
  const history = useHistory();
  const { storeBrands } = useSelector((state: IReduxState) => state.brands);
  const {
    store_products: {
      store_products_sku,
      catalogProducts
    },
    productsLoading
  } = useSelector((state: IReduxState) => state.products);
  const {isLoading} = useSelector((state: IReduxState) => state.home);
  const {bestsellers} = useSelector((state: IReduxState) => state.home.storeStatistic);
  const listOfBestsellersProducts = bestsellers || [];

  const columns = [
    {
      name: 'Name',
      lable: 'Name',
      options: {
        setCellHeaderProps: () => ({className: classes.tableTitle, style: { width: '50%'}}),
        customBodyRenderLite: (dataIndex) => {
          const product = listOfBestsellersProducts[dataIndex];
          return (
            <div className="flex items-center">
              <img
                src={product.product_image_url ? product.product_image_url : logo}
                alt={product.name}
                style={{maxHeight: '60px', width: '60px', objectFit: 'contain'}}
              />
              <div className="ml-3">
                <p className={classes.tableRowText} >{product.product_name}</p>
              </div>
            </div>
          );
        }
      }
    },
    {
      name: 'Revenue',
      lable: 'Revenue',
      options: {
        setCellHeaderProps: () => ({className: classes.tableTitle, style: { width: '16%'}}),
        customBodyRenderLite: (dataIndex) => {
          const product = listOfBestsellersProducts[dataIndex];
          return (
            <div>
              <NumberFormat
                className={classes.tableRowText}
                fixedDecimalScale
                decimalScale={1}
                value={product.product_price * product.bought_quantity}
                displayType="text"
                thousandSeparator
                prefix="$"
              />
            </div>
          );
        }
      }
    },
    {
      name: 'Stock Status',
      lable: 'Stock Status',
      options: {
        setCellHeaderProps: () => ({className: classes.tableTitle, style: { width: '21%'}}),
        customBodyRenderLite: (dataIndex) => {
          const product = listOfBestsellersProducts[dataIndex];
          return (
            <div className={`${classes.tableRowText} flex justify-center`}>
              <Chip label={product.in_stock ? 'In stock' : 'Out of stock'} color={product.in_stock ? 'primary' : 'default'} />
            </div>
          );
        }
      }
    },
    {
      name: 'Action',
      lable: 'Action',
      options: {
        setCellHeaderProps: () => ({className: classes.tableTitle, style: { width: '10%'}}),
        customBodyRenderLite: (dataIndex) => {
          const product = listOfBestsellersProducts[dataIndex];
          const isProductOnStore = store_products_sku.find((productSku) => product.product_sku === productSku);
          const activeProductData = catalogProducts.find((el) => el.sku === product.product_sku);
          const productBrandId = activeProductData?.custom_attributes?.find((attr) => attr.attribute_code === 'brand')?.value;
          const productBrand = storeBrands?.find((b) => b.option_id === productBrandId)?.value || '';

          return (
            <div className="flex items-center">
              {isProductOnStore &&
                <IconButton
                  className="m-0"
                  title="Click here to make edits to your item (e.g.: name, price, options, subscription, etc.)"
                  onClick={() => {
                    history.push({pathname: `/store-products/edit/${product.product_sku}`, search: `?brand=${productBrand}`});
                  }}
                >
                  <Icon className="text-gray">edit</Icon>
                </IconButton>
              }
            </div>
          );
        }
      }
    }
  ];
  return (
    <Card className="m-2 py-5 px-1 min-h-520 relative">
      <div className="py-4 px-1 text-gray">
        <Typography className="m-4 text-gray" variant="h5">The best sellers</Typography>
        <MUIDataTable
          data={listOfBestsellersProducts}
          columns={columns}
          className={classes.root}
          options={{
            responsive: 'standard',
            selectableRows: 'none',
            sort: false,
            search: false,
            filter: false,
            download: false,
            print: false,
            pagination: false,
            viewColumns: false,
            elevation: 0,
            rowsPerPage: 4,
          }}
        />
      </div>
      <BackdropCircular loading={isLoading || productsLoading} title="Collecting data..." local />
    </Card>
  );
};

export default BestSellers;
